<div class="container-fluid bg-body-tertiary py-5" *ngIf="sucursales.length > 0">
  <div class="container text-center">

    <p class="fs-2 fw-bold" style="color:var(--primary-color);">Centros Médicos Disponibles</p>
  </div>


  <div class="container">
    <div class="d-flex row gap-2 justify-content-center  py-5">
  <span *ngFor="let sucursal of sucursales; let i= index" class="col-auto  badge  align-items-center p-1 pe-2 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-pill">
    <span class=" mx-auto   ">
        <a [href]="sucursal.linkMaps" target="_blank"><i style="color: var(--terciary-color)" class="bi bi-geo-alt-fill fs-6  rounded-circle me-1"></i>{{ sucursal.nameSucursal }}</a>
    </span>
  </span>
    </div>

  </div>
</div>




